module.exports = __webpack_public_path__ + "media/images/ic-check-green-aec15129190276656fa8bac853eb218a.svg";